import * as React from "react";

interface FileUploadProps {
    className?: string;
    onClick?: () => void;
}

export function FileUpload(props: FileUploadProps) {
    return (
        <div {...props}>
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M9 4.25V0H2.75C2.33437 0 2 0.334375 2 0.75V15.25C2 15.6656 2.33437 16 2.75 16H13.25C13.6656 16 14 15.6656 14 15.25V5H9.75C9.3375 5 9 4.6625 9 4.25ZM11.0369 11.0003H9V13.5003C9 13.7766 8.77625 14.0003 8.5 14.0003H7.5C7.22375 14.0003 7 13.7766 7 13.5003V11.0003H4.96312C4.51688 11.0003 4.29406 10.46 4.61094 10.1453L7.62406 7.15469C7.83187 6.94812 8.1675 6.94812 8.37531 7.15469L11.3884 10.1453C11.7056 10.46 11.4831 11.0003 11.0369 11.0003ZM13.7812 3.28125L10.7219 0.21875C10.5813 0.078125 10.3906 0 10.1906 0H10V4H14V3.80938C14 3.6125 13.9219 3.42188 13.7812 3.28125Z"
                    fill="white"
                />
            </svg>
        </div>
    );
}
